import axios from "axios"

let baseURL;
let apiKey;

const app = global.window && window?.location && window?.location?.origin;
if (app === 'https://www.weriseapp.co') {
    baseURL = 'https://we-arise-backend-api.herokuapp.com/api/v1';
    apiKey = 'jhfhdh88743..4$$fhhfhjfh'
} else {
    baseURL = 'https://we-arise-backend-api-test.herokuapp.com/api/v1';
    apiKey = 'jhfhdh88743..4$$fhhfhjfh'
}


const accessToken = global.window && window.localStorage && localStorage?.getItem('token');

axios.defaults.headers.common["Authorization"] = `Bearer ${(accessToken)}`;

const axiosApiInstance = axios.create({
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'apiKey': apiKey
    }
})

axiosApiInstance.defaults.baseURL = baseURL;

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
    async config => {
        const access_token = JSON.parse(localStorage.getItem('token'));

        config.headers = {
            'Authorization': `Bearer ${access_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'apiKey': apiKey
        }
        return config;
    },
    error => {
        Promise.reject(error)
    });

//   // Response interceptor for API calls
axiosApiInstance.interceptors.response.use((response) => {
    return response
}, async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        const access_token = JSON.parse(localStorage.getItem('token'));

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
});

export const WeriseServiceAPI = {
    searchCandidate: async (state, municipal, district, county) => {
        try {
            const res = await axiosApiInstance.get(`/candidates/search?${municipal && `municipal=${municipal}`}${state && `&state=${state}`}${district && `&district=${district}`}${county && `&county=${county}`}`);
            return res;

        } catch (error) {
            console.error({ error })
        }
    },
    searchPollingPlaces: async (seat, municipal, category, county, zip_code, polling_place) => {
        try {
            const res = await axiosApiInstance.get(`/polling-places/search?${county && `county=${county}`}${category && `&category=${category}`}${municipal && `&municiple_name=${municipal}`}${seat && `&seat=${seat}`}${zip_code && `&zip_code=${zip_code}`}${polling_place && `&polling_place=${polling_place}`}`);
            return res;
        } catch (error) {

        }
    }


    // searchPollingPlaces: async (seat, municipal, category, county) => {
    //     try {

    //         const res = await axiosApiInstance.get(`/polling-places/search?${county && `county=${county}`}${category && `&category=${category}`}${municipal && `&municiple_name=${municipal}`}${seat && `&seat=${seat}`}`)
    //         return res;
    //     } catch (err) {
    //         console.log({ err })

    //     }

}
